import React from "react"
import i18n from "@/i18n"

type GuestsStepProps = {
  selectedPeopleAmount: number | null
  availableGuestCounts: number[]
  onPeopleAmountChange: (peopleAmount: number) => void
  onContinue: () => void
  showContinueButton?: boolean
}

const GUEST_OPTIONS = Array.from({ length: 12 }, (_, index) => index + 1)

const ACTION_BUTTON_STYLES =
  "mt-5 flex h-[34px] w-full items-center justify-center rounded-[5px] bg-[#2596fa] text-sm font-medium text-white transition-colors hover:bg-[#1f84dd] disabled:cursor-not-allowed disabled:bg-[rgba(37,150,250,0.6)]"

const GuestsStep: React.FC<GuestsStepProps> = ({
  selectedPeopleAmount,
  availableGuestCounts,
  onPeopleAmountChange,
  onContinue,
  showContinueButton = true,
}) => {
  const hasSelection = selectedPeopleAmount !== null && availableGuestCounts.includes(selectedPeopleAmount)

  return (
    <div className="flex flex-col" data-testid="public-venue-sidebar-guests-step">
      <div className="grid grid-cols-4 gap-x-[4px] gap-y-[6px]" data-testid="public-venue-sidebar-guests-grid">
        {GUEST_OPTIONS.map((guestCount) => {
          const isSelected = hasSelection && guestCount === selectedPeopleAmount
          const isAvailable = availableGuestCounts.includes(guestCount)

          return (
            <button
              key={guestCount}
              type="button"
              disabled={!isAvailable}
              onClick={() => onPeopleAmountChange(guestCount)}
              aria-pressed={isSelected}
              aria-label={i18n.t("app.public.venue.guests", { count: guestCount })}
              data-selected={isSelected}
              data-testid={`public-venue-sidebar-guests-option-${guestCount}`}
              className={`flex h-[30px] items-center justify-center rounded-[3px] border text-[14px] text-center leading-[normal] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2596fa] ${
                !isAvailable
                  ? "cursor-not-allowed border-[#e9e9e9] bg-white text-[rgba(23,23,23,0.35)]"
                  : isSelected
                    ? "border-[#2596fa] bg-[#2596fa] font-medium text-white"
                    : "border-[#e9e9e9] bg-white font-normal text-[rgba(23,23,23,0.7)] hover:border-[#cbcbcb] hover:bg-[#f3f3f3] hover:font-medium"
              }`}
            >
              {guestCount}
            </button>
          )
        })}
      </div>

      {showContinueButton && (
        <button
          type="button"
          onClick={onContinue}
          disabled={!hasSelection}
          className={ACTION_BUTTON_STYLES}
          data-testid="public-venue-sidebar-guests-continue"
        >
          {i18n.t("app.public.venue.sidebar.how_many_guests")}
        </button>
      )}
    </div>
  )
}

export default GuestsStep
